import { FormattedMessage } from 'react-intl';

import { InputProps, TextField } from '@mui/material';

import styled from 'styled-components';

import { Flag } from './Flag';

const StyledCountrySelectInput = styled(TextField)`
  .input-flag {
    padding: ${({ theme }) => theme.spacing(0, 1)};
  }
`;

export const CountrySelectInput = ({
  value,
  InputProps,
  ...rest
}: unknown & {
  value?: string;
  InputProps?: InputProps;
}) => {
  return (
    <StyledCountrySelectInput
      label={<FormattedMessage id="country" defaultMessage="Country" />}
      InputProps={{
        ...InputProps,
        startAdornment: <Flag value={value} className="input-flag" />,
      }}
      {...rest}
    />
  );
};
